var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJamf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8511 11.1074C12.0683 11.1109 11.4364 11.7484 11.44 12.5312L11.4841 22.3321C11.4876 23.0952 12.1089 23.7111 12.872 23.7075L17.8116 23.6852C20.0727 23.6751 23.1748 23.1968 24.0093 19.1778C24.0098 19.1769 24.8384 15.1532 25.3296 12.7681C25.512 11.881 24.8318 11.0534 23.9262 11.0574L12.8511 11.1074Z",
    fill: "#748AB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7753 15.6705C28.4398 15.6856 26.4752 17.0991 25.5912 20.1181C25.5929 20.112 23.3005 27.3076 23.3005 27.3076C22.4593 29.6708 21.0925 30.6491 18.5898 30.6604L12.8479 30.6863C12.1155 30.6895 11.5246 31.2859 11.5278 32.0185L11.5443 35.6802C11.5476 36.3805 12.1179 36.9459 12.8183 36.9429L36.1223 36.8377C36.8532 36.8344 37.443 36.2392 37.4398 35.5085L37.3559 16.9213C37.3527 16.2167 36.7791 15.648 36.0742 15.6513L31.7753 15.6705Z",
    fill: "#748AB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamf);
export default __webpack_public_path__ + "static/media/Jamf.c603b09422077bb8c3a565f7f324744f.svg";
export { ForwardRef as ReactComponent };